package com.ijoin.platform

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlin.js.Date

private fun browserTimeZoneId(): String? =
    (js("Intl.DateTimeFormat().resolvedOptions().timeZone") as? String)?.takeIf { it.isNotBlank() }

private fun effectiveTimeZoneId(timeZone: TimeZone): String =
    timeZone.displayId.takeUnless { it == "SYSTEM" } ?: browserTimeZoneId().orEmpty().ifBlank { "UTC" }

private fun formatDateForTimeZone(timeZoneId: String): String {
    val options: dynamic = js("({})")
    options.timeZone = timeZoneId
    options.year = "numeric"
    options.month = "2-digit"
    options.day = "2-digit"
    return Date().toLocaleDateString("en-CA", options)
}

actual fun getCurrentDate(timeZone: TimeZone): LocalDate {
    val dateString = formatDateForTimeZone(effectiveTimeZoneId(timeZone))
    val parts = dateString.split("-")
    return LocalDate(
        year = parts[0].toInt(),
        monthNumber = parts[1].toInt(),
        dayOfMonth = parts[2].toInt()
    )
}




